import createOpenApiClient, { type ClientOptions } from "openapi-fetch";
import type { paths } from "./schema.js";

export type { paths, components } from "./schema.js";

// The one HTTP client every frontend surface uses (doctrine 3: no hand-rolled
// fetch types anywhere — apps/web consumes only this package). Regenerated from
// openapi/v1.json via `pnpm client:generate`; the generated schema.d.ts is
// committed and pinned in CI alongside the OpenAPI snapshot.
export function createClient(options?: ClientOptions) {
  return createOpenApiClient<paths>({
    // Same-origin by default: each surface is served from its tenant subdomain
    // and calls /v1/* paths on that same origin (spec 16 §3.1 — the tenant is
    // always the subdomain; there is no separate API host).
    baseUrl: "",
    credentials: "include",
    ...options,
  });
}

export type ApiClient = ReturnType<typeof createClient>;
